import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";
import { GetWaiverModel } from "@factory/model/query-model-waiver";
import { waiverFormDefault } from "./form.default";
import { WaiverFormSchema } from "./form.rule";

export const useFormDefaultWaiver = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetWaiverModel | undefined) => {
    return !cachedValue
      ? waiverFormDefault
     : ({
        tenant: cachedValue.tenant,
        name: cachedValue.name,
        description: cachedValue.description,
      } as WaiverFormSchema);
  };

  return {
    getDefault,
  };
};
